import React, {useEffect, useEffectEvent, useRef} from "react";
import {FocusScope} from "@react-aria/focus";
import PropTypes from "prop-types";

import {Portal} from "./Portal";

export function Modal(props) {
  const modalRef = useRef(null);

  const onClose = useEffectEvent(() => {
    props.onClose?.();
  });

  // Prevent scroll and add event listeners when modal is open
  useEffect(() => {
    if (!props.isOpen) return;

    document.body.style.overflow = "hidden" // Prevent scroll behind modal

    function handleClickOutside(event) {
      if (!modalRef.current) return;
      if (modalRef.current.contains(event.target)) return;
      onClose();
    }

    function handleKeyDown(event) {
      if (event.key === "Escape") onClose();
    }

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.body.style.overflow = "initial"
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [props.isOpen, onClose]);

  if (!props.isOpen) return null;

  return (
    <Portal>
      <div className="account-modal">
        <FocusScope contain restoreFocus autoFocus>
          <div ref={modalRef} tabIndex={-1} className="account-modal__content">
            {props.children}
          </div>
        </FocusScope>
      </div>
    </Portal>
  );
}

Modal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}
